import { connect } from 'react-redux';

import { actionCreators as userActionCreators, selectors as userSelectors } from 'dux/user';
import OrgImpersonationForm from './OrgImpersonationForm';

const mapStateToProps = (state) => ({
  user: userSelectors.getIdentityState(state),
});

const mapDispatchToProps = {
  searchOrgs: userActionCreators.searchOrgs,
  sortOrgs: userActionCreators.sortOrgs,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgImpersonationForm);
